import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient'

export default {
	async [actionTypes.ITEM_ADESAO.BUSCAR_ITENS_PARA_ANUENCIA](context, parametros) {
		let { data } = await api.itemAdesao.buscarItensParaAnuencia(parametros)
		return data
	},
	async [actionTypes.ITEM_ADESAO.RECUSAR_ITEM](context, parametros) {
		await api.itemAdesao.recusarItemAdesao(parametros)
	},
	async [actionTypes.ITEM_ADESAO.ACEITAR_ITEM](context, parametros) {
		await api.itemAdesao.aceitarItemAdesao(parametros)
	},
	async [actionTypes.ITEM_ADESAO.GERAR_DOCUMENTO](context, parametros) {
		await api.itemAdesao.gerarDocumento(parametros)
	},
}
